import { Typography, withStyles } from "@material-ui/core";
import { Button } from "bc-front-sagacomponents";
import React from "react";
import { logout } from "../../services/Authentification/authentification";
import styles from "./style";

interface Props {
  classes?: any;
}
const ForbiddenPage = (props: Props) => {
  const { classes } = props;
  return (
    <div className={classes.forbiddenPage}>
      {" "}
      <Typography variant="h1">Accès interdit</Typography>
      <Typography variant="body1">
        Vous n'êtes pas autorisé(e) à accéder à ce site.
      </Typography>
      <Button
        onClick={() => logout()}
        title="Retour à la page d'accueil"
        variant="contained"
        color="primary"
      />
    </div>
  );
};

export default withStyles(styles)(ForbiddenPage);
